module.exports = __webpack_public_path__ + "static/img/login_bg.cf662b37.png";